import * as React from 'react';
import ReactDOM from 'react-dom';
import { MouseEventHandler } from '../types/typescript/eventHandlers';
import pickGlobalElementProps from 'utils/pickInputElementProps';

import DOM from 'lib/DOM';

const stack: Array<ScrollContext> = [];

type Props = {
  children: React.ReactNode;
  tabIndex: number;
  className: string;
  onClick?: MouseEventHandler | null;
};

type PosType = {
  left?: number;
  top?: number;
};

class ScrollContext extends React.Component<Props> {
  componentWillMount() {
    const context = stack[stack.length - 1];
    if (context) {
      context.fix();
      scrollTo(0, 0);
    }
  }

  componentDidMount() {
    stack.push(this);
  }

  componentWillUnmount() {
    const index = stack.indexOf(this);
    if (index >= 0) {
      stack.splice(index, 1);

      const context = stack[stack.length - 1];
      if (context) {
        context.restore();
      }
    }
  }

  _pos: PosType | undefined | null;

  fix = () => {
    const pos = DOM.getScrollPosition();

    const node = ReactDOM.findDOMNode(this);
    if (!(node instanceof HTMLElement)) {
      throw new Error('ScrollContext.fix findDOMNode returned non HTMLElement');
    }

    node.style.cssText = `position: fixed;left: -${pos.left}px;top: -${pos.top}px;`;

    this._pos = pos;
  };

  restore = () => {
    const node = ReactDOM.findDOMNode(this);
    if (!(node instanceof HTMLElement)) {
      throw new Error('ScrollContext.restore findDOMNode returned non HTMLElement');
    }

    node.style.cssText = '';

    if (this._pos && this._pos.left && this._pos.top) {
      scrollTo(this._pos.left, this._pos.top);
      this._pos = null;
    }
  };

  render() {
    const props = pickGlobalElementProps(this.props);
    return <div {...props}>{this.props.children}</div>;
  }
}

const MockScrollContext = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;

export default typeof window === 'undefined' ? MockScrollContext : ScrollContext;
